/*! Express Matting – product page (sections/main-product-pro.liquid). Vanilla, no dependencies. */
(() => {
  'use strict';
  if (!('customElements' in window) || customElements.get('emx-pdp')) return;

  const $ = (r, s) => (r ? r.querySelector(s) : null);
  const $$ = (r, s) => (r ? Array.prototype.slice.call(r.querySelectorAll(s)) : []);
  const warn = (e) => { try { console.warn('[emx-pdp]', e); } catch (_) { /* noop */ } };
  const mq = (q) => !!(window.matchMedia && window.matchMedia(q).matches);
  const reduced = () => mq('(prefers-reduced-motion: reduce)');
  const EPS = 1e-6;
  const up = (x) => Math.ceil(x - EPS);
  const num = (x) => { const n = parseFloat(String(x == null ? '' : x).replace(',', '.')); return isFinite(n) ? n : NaN; };
  const t2 = (x) => String(Math.round(x * 100) / 100);
  const setText = (el, t) => { if (el && el.textContent !== t) el.textContent = t; };
  const show = (el, on) => { if (el && el.hidden === !!on) el.hidden = !on; };
  const lbl = (s) => String(s == null ? '' : s).split(' | ')[0];
  /* Short product name: text before " | ", else before " – ", " — ", " - " or ", " when that part is 12+ chars. */
  const shortName = (s) => {
    s = String(s == null ? '' : s);
    if (s.indexOf(' | ') > -1) return s.split(' | ')[0].trim();
    const seps = [' – ', ' — ', ' - ', ', '];
    for (let i = 0; i < seps.length; i++) { const p = s.split(seps[i]); if (p.length > 1 && p[0].length >= 12) return p[0].trim(); }
    return s;
  };
  const enc = encodeURIComponent;
  /* Leading number of an option label ("12ft x 27inches" -> 12), NaN when it does not start with one. */
  const lead = (s) => { const m = String(s == null ? '' : s).match(/^\s*(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : NaN; };
  /* True when every value starts with a number and, in numeric order, a larger value costs less. */
  const nonMono = (arr) => {
    if (arr.length < 2 || arr.some((e) => isNaN(e.n))) return false;
    const s = arr.filter((e) => e.p != null).sort((a, b) => (a.n - b.n) || (a.p - b.p));
    for (let i = 1; i < s.length; i++) if (s[i].p < s[i - 1].p) return true;
    return false;
  };
  const CUT_PROP = 'Cut into';
  /* Hidden (underscore) property: makes every cut-list add its own basket line, so two adds of the same
     cut list are never merged into one line whose cutting instruction no longer matches the quantity.
     Warehouse's cart and mini-cart skip "_" keys, and Shopify checkout hides them. */
  const CUT_REF = '_cut_ref';
  const EDGE_RX = /\b(ramp|corner|edge|edging|strip)s?\b/i;
  const store = {
    get(k) { try { return JSON.parse(window.sessionStorage.getItem(k) || 'null'); } catch (_) { return null; } },
    set(k, v) { try { window.sessionStorage.setItem(k, JSON.stringify(v)); } catch (_) { /* private mode */ } }
  };
  const openDialog = (d) => { if (!d) return; try { if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); } else d.setAttribute('open', ''); } catch (_) { d.setAttribute('open', ''); } };
  const closeDialog = (d) => { if (!d) return; try { if (typeof d.close === 'function') d.close(); else { d.removeAttribute('open'); d.dispatchEvent(new Event('close')); } } catch (_) { d.removeAttribute('open'); } };

  /* ---------- Dimension parser (port of catalog-data/parse.ps1) ---------- */
  const N = '(\\d+(?:\\.\\d+)?)';
  const U = '(mm|cm|metres|meters|metre|meter|m|ft|feet|inches|inch|in|")';
  const toM = (v, u) => {
    v = parseFloat(v); u = (u || '').toLowerCase();
    if (u === 'mm') return v / 1000;
    if (u === 'cm') return v / 100;
    if (/^(m|metres?|meters?)$/.test(u)) return v;
    if (/^(ft|feet)$/.test(u)) return v * 0.3048;
    if (/^(inch(es)?|in|")$/.test(u)) return v * 0.0254;
    return null;
  };
  const RX = {
    w1: new RegExp(N + '\\s*' + U + '\\s*(?:wide|width)\\b', 'i'),
    w2: new RegExp('width:?\\s*' + N + '\\s*' + U, 'i'),
    l1: new RegExp(N + '\\s*' + U + '\\s*(?:length|long)\\b', 'i'),
    l2: new RegExp('length:?\\s*' + N + '\\s*' + U, 'i'),
    x: new RegExp(N + '\\s*' + U + '?\\s*(?:length|long)?\\s*[x×]\\s*' + N + '\\s*' + U + '?', 'i'),
    one: new RegExp('^\\s*' + N + '\\s*' + U, 'i'),
    glue: /(\d+)\s*kg\s*to\s*cover\s*(\d+)\s*sq/i
  };
  function dims(s) {
    s = String(s || '').replace(/\s+/g, ' ');
    const r = { L: null, W: null };
    let m;
    if ((m = s.match(RX.w1))) r.W = toM(m[1], m[2]);
    else if ((m = s.match(RX.w2))) r.W = toM(m[1], m[2]);
    if ((m = s.match(RX.l1))) r.L = toM(m[1], m[2]);
    else if ((m = s.match(RX.l2))) r.L = toM(m[1], m[2]);
    if (!(r.L && r.W) && (m = s.match(RX.x))) {
      const u1 = m[2] || m[4], u2 = m[4] || m[2];
      if (u1 && u2) {
        const a = toM(m[1], u1), b = toM(m[3], u2);
        if (a != null && b != null) {
          if (!r.L && !r.W) { r.L = Math.max(a, b); r.W = Math.min(a, b); }
          else if (r.W && !r.L) r.L = Math.abs(a - r.W) < 1e-3 ? b : a;
          else if (r.L && !r.W) r.W = Math.abs(a - r.L) < 1e-3 ? b : a;
        }
      }
    }
    return r;
  }

  class EmxPdp extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      const island = $(this, 'script[data-emx-json]');
      if (!island) return;
      let d;
      try { d = JSON.parse(island.textContent); } catch (e) { warn(e); return; }
      this._ready = true;
      this.d = d;
      this.d.flags = d.flags || {};
      this._off = [];
      this._obs = [];
      this._timers = [];
      this._ac = typeof AbortController === 'function' ? new AbortController() : null;
      this.V = Array.isArray(d.v) ? d.v : [];
      this.usable = this.d.flags.splitAcc ? this.V.filter((v) => !v.acc) : this.V;
      this.form = $(this, 'form[data-emx-form]');
      this.idCtrl = this.form ? this.form.elements.namedItem('id') : null;
      const initId = this.idCtrl ? Number(this.idCtrl.value) : NaN;
      const v0 = this.byId(initId) || this.usable[0] || this.V[0] || null;
      this.state = { variant: v0, sel: v0 ? v0.o.slice() : [], qty: 1, acc: {}, calc: {}, cut: null };
      this._overlays = new Set();
      ['gallery', 'lightbox', 'options', 'buy', 'acc', 'calc', 'sticky', 'added', 'fbt', 'quote', 'details', 'trust', 'cards'].forEach((m) => {
        try { this['m_' + m](); } catch (e) { warn(e); }
      });
      this.render(true);
      if (window.Shopify && window.Shopify.designMode) {
        try { if (window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) window.Shopify.PaymentButton.init(); } catch (e) { warn(e); }
      }
    }

    disconnectedCallback() {
      if (!this._ready) return;
      this._ready = false;
      this._off.forEach((f) => { try { f(); } catch (_) { /* noop */ } });
      this._obs.forEach((o) => { try { o.disconnect(); } catch (_) { /* noop */ } });
      this._timers.forEach((t) => clearTimeout(t));
      clearTimeout(this._annT);
      if (this._ac) { try { this._ac.abort(); } catch (_) { /* noop */ } }
      if (document.body) document.body.classList.remove('emx-sticky-on', 'emx-added-on');
      try { document.documentElement.style.scrollPaddingBottom = ''; } catch (_) { /* noop */ }
      this._off = []; this._obs = []; this._timers = [];
    }

    on(t, type, fn, opts) {
      if (!t || !t.addEventListener) return;
      t.addEventListener(type, fn, opts);
      this._off.push(() => t.removeEventListener(type, fn, opts));
    }
    later(fn, ms) { const t = setTimeout(() => { try { fn(); } catch (e) { warn(e); } }, ms); this._timers.push(t); return t; }
    byId(id) { id = Number(id); return this.V.find((v) => v.id === id) || null; }
    fmt(p) {
      const money = String(this.d.money || '£{{amount}}').replace(/&pound;/g, '£').replace(/&amp;/g, '&');
      return money.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
        const n = (Number(p) || 0) / 100;
        if (k === 'amount_no_decimals') return Math.round(n).toLocaleString('en-GB');
        const s = n.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return k === 'amount_with_comma_separator' ? s.replace(/,/g, ' ').replace('.', ',') : s;
      });
    }
    exVat(v, amount) { return v && v.tx ? Math.round(amount / (1 + (Number(this.d.vat) || 20) / 100)) : amount; }
    disp(v, amount) { return this.d.taxExempt ? this.exVat(v, amount) : amount; }
    get metre() { return !!this.d.flags.metre; }
    anyAcc() { return Object.keys(this.state.acc).some((k) => this.state.acc[k] > 0); }
    qtyText(q) { q = q == null ? this.state.qty : q; return this.metre ? q + ' m' : String(q); }
    signal() { return this._ac ? this._ac.signal : undefined; }
    vatWord() { return this.d.taxExempt ? 'ex VAT' : 'inc VAT'; }
    /* Option text for a variant, or '' when it would only repeat the product name. Options whose values
       share a long part (section: d.dd) read as the picker shows them plus that part, once:
       "Grey · 24 × 24 in (61 × 61 cm) · 12 mm thick"; with two options, the short labels first, then the
       shared parts, all joined with " · " ("Ramp Tile · Forest Green · 500 × 500 × 30 mm"). */
    optText(v) {
      if (!v || v.t === 'Default Title' || this.V.length === 1) return '';
      const dd = Array.isArray(this.d.dd) ? this.d.dd : [];
      const o = v.o || [];
      if (o.some((x, i) => dd[i] && dd[i].s && dd[i].s[x] != null)) {
        const shorts = [], commons = [];
        o.forEach((x, i) => {
          const g = dd[i], s = g && g.s ? g.s[x] : null;
          if (s != null) { shorts.push(s); if (g.c && commons.indexOf(g.c) === -1) commons.push(g.c); }
          else if (x != null && x !== '') shorts.push(lbl(x));
        });
        return shorts.concat(commons).join(' · ');
      }
      const t = lbl(v.t);
      return t === this.d.title || t === lbl(this.d.full) ? '' : t;
    }
    radioFor(i, x) { return (this.radios || []).find((r) => Number(r.getAttribute('data-emx-oi')) === i && r.value === x) || null; }
    /* Compact option summary from the labels the picker shows (e.g. "Black · 4mm"). */
    optSummary(v) {
      if (!this.optText(v)) return '';
      const parts = [];
      (v.o || []).forEach((x, i) => {
        if (this.fac && i === this.fac.oi) { const f = this.fac.vals[x]; if (f) { parts.push(f.c, f.t); return; } }
        const r = this.radioFor(i, x);
        const te = r && r.nextElementSibling ? $(r.nextElementSibling, '.emx-choice__text') : null;
        const t = te ? te.textContent.trim() : '';
        if (t) parts.push(t);
        else if (String(x).indexOf(' | ') === -1 && String(x).length <= 40) parts.push(lbl(x));
      });
      return parts.join(' · ');
    }

    /* ---------- Render: one source of truth ---------- */
    render(init) {
      ['rPrice', 'rOptions', 'rCut', 'rBuy', 'rSku', 'rSticky', 'rHelp', 'rCalc'].forEach((f) => {
        try { this[f](init); } catch (e) { warn(e); }
      });
      if (init) { try { this.scrollLists(); } catch (e) { warn(e); } }
    }

    /* ---------- Gallery ---------- */
    m_gallery() {
      const g = $(this, '[data-emx-gallery]');
      const track = $(g, '[data-emx-track]');
      if (!g || !track) return;
      const slides = $$(track, '.emx-gallery__slide');
      this.g = { g, track, slides, idx: 0, count: $(g, '[data-emx-count]'), thumbs: $$(g, '[data-emx-thumb]'), thumbBox: $(g, '[data-emx-thumbs]'), zoom: $(g, '[data-emx-zoom]') };
      let raf = 0;
      this.on(track, 'scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = 0;
          const w = track.clientWidth || 1;
          const i = Math.round(track.scrollLeft / w);
          if (i !== this.g.idx) this.setSlide(i);
        });
      }, { passive: true });
      this.on(track, 'keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(this.g.idx - 1, true); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.g.idx + 1, true); }
        else if (e.key === 'Enter' && e.target === track) { e.preventDefault(); this.openLightbox(this.g.idx, track); }
      });
      this.on($(g, '[data-emx-prev]'), 'click', () => this.goTo(this.g.idx - 1, true));
      this.on($(g, '[data-emx-next]'), 'click', () => this.goTo(this.g.idx + 1, true));
      this.g.thumbs.forEach((b) => this.on(b, 'click', () => this.goTo(Number(b.getAttribute('data-emx-thumb')) || 0, true)));
      this.on(this.g.zoom, 'click', (e) => this.openLightbox(this.g.idx, e.currentTarget));
      this.on(track, 'click', (e) => {
        const play = e.target.closest && e.target.closest('[data-emx-play]');
        if (play) { this.playSlide(play.closest('.emx-gallery__slide')); return; }
        const img = e.target.closest && e.target.closest('.emx-gallery__img');
        const slide = img && img.closest('.emx-gallery__slide');
        if (slide && slide.hasAttribute('data-zoom')) this.openLightbox(slides.indexOf(slide), track);
      });
    }
    goTo(i, smooth) {
      if (!this.g) return;
      const n = this.g.slides.length;
      if (!n) return;
      i = ((i % n) + n) % n;
      const left = i * this.g.track.clientWidth;
      try { this.g.track.scrollTo({ left, behavior: smooth && !reduced() ? 'smooth' : 'auto' }); } catch (_) { this.g.track.scrollLeft = left; }
      this.setSlide(i);
    }
    setSlide(i) {
      const g = this.g;
      if (!g || i < 0 || i >= g.slides.length) return;
      g.idx = i;
      setText(g.count, (i + 1) + ' / ' + g.slides.length);
      g.thumbs.forEach((b, k) => b.setAttribute('aria-current', k === i ? 'true' : 'false'));
      const tb = g.thumbs[i], box = g.thumbBox;
      if (tb && box) {
        if (box.scrollHeight > box.clientHeight + 2) {
          if (tb.offsetTop < box.scrollTop) box.scrollTop = tb.offsetTop;
          else if (tb.offsetTop + tb.offsetHeight > box.scrollTop + box.clientHeight) box.scrollTop = tb.offsetTop + tb.offsetHeight - box.clientHeight;
        } else if (box.scrollWidth > box.clientWidth + 2) {
          if (tb.offsetLeft < box.scrollLeft) box.scrollLeft = tb.offsetLeft;
          else if (tb.offsetLeft + tb.offsetWidth > box.scrollLeft + box.clientWidth) box.scrollLeft = tb.offsetLeft + tb.offsetWidth - box.clientWidth;
        }
      }
      if (g.zoom) show(g.zoom, g.slides[i].hasAttribute('data-zoom'));
      g.slides.forEach((s, k) => { if (k !== i) this.stopSlide(s); });
    }
    goToMedia(mediaId) {
      if (!this.g || mediaId == null) return;
      const i = this.g.slides.findIndex((s) => String(s.getAttribute('data-media-id')) === String(mediaId));
      if (i >= 0 && i !== this.g.idx) this.goTo(i, false);
    }
    playSlide(slide) {
      if (!slide) return;
      const tpl = $(slide, 'template[data-emx-player]');
      const media = $(slide, '.emx-gallery__media');
      if (!tpl || !media || $(slide, '.emx-gallery__player')) return;
      const wrap = document.createElement('div');
      wrap.className = 'emx-gallery__player';
      wrap.appendChild(tpl.content.cloneNode(true));
      media.appendChild(wrap);
      slide.classList.add('is-playing');
      const video = $(wrap, 'video');
      const frame = $(wrap, 'iframe');
      if (video) {
        try { const p = video.play(); if (p && p.catch) p.catch(() => {}); } catch (_) { /* noop */ }
        try { video.focus(); } catch (_) { /* noop */ }
      } else if (frame) {
        frame.setAttribute('tabindex', '0');
        try { frame.focus(); } catch (_) { /* noop */ }
      }
    }
    stopSlide(slide) {
      if (!slide || !slide.classList.contains('is-playing')) return;
      const wrap = $(slide, '.emx-gallery__player');
      const video = $(wrap, 'video');
      if (video) { try { video.pause(); } catch (_) { /* noop */ } return; }
      if (wrap) wrap.remove();
      slide.classList.remove('is-playing');
    }

    /* ---------- Lightbox ---------- */
    m_lightbox() {
      const lb = $(this, '[data-emx-lightbox]');
      if (!lb || !this.g) return;
      this.lb = { el: lb, img: $(lb, '[data-emx-lb-img]'), wrap: $(lb, '[data-emx-lb-wrap]'), count: $(lb, '[data-emx-lb-count]'), list: this.g.slides.filter((s) => s.hasAttribute('data-zoom')), pos: 0, ret: null };
      this.lb.zoomBtn = $(lb, '[data-emx-lb-zoom]');
      this.on($(lb, '[data-emx-lb-close]'), 'click', () => closeDialog(lb));
      this.on($(lb, '[data-emx-lb-prev]'), 'click', () => this.lbShow(this.lb.pos - 1));
      this.on($(lb, '[data-emx-lb-next]'), 'click', () => this.lbShow(this.lb.pos + 1));
      this.on(lb, 'keydown', (e) => {
        /* While zoomed, arrow keys pan the focused image area instead of changing image. */
        if (lb.classList.contains('is-zoomed')) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.lbShow(this.lb.pos - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); this.lbShow(this.lb.pos + 1); }
      });
      this.on(this.lb.img, 'click', (e) => {
        if (lb.classList.contains('is-nozoom')) return;
        const img = this.lb.img;
        const r = img.getBoundingClientRect();
        const px = r.width ? (e.clientX - r.left) / r.width : 0.5;
        const py = r.height ? (e.clientY - r.top) / r.height : 0.5;
        this.lbZoom(!lb.classList.contains('is-zoomed'), px, py);
      });
      /* Keyboard-operable zoom (the image itself is only mouse-clickable). */
      this.on(this.lb.zoomBtn, 'click', () => this.lbZoom(!lb.classList.contains('is-zoomed'), 0.5, 0.5));
      this.on(lb, 'close', () => {
        this.lbZoom(false);
        this.overlay('lightbox', false);
        const r = this.lb.ret;
        if (r && r.focus) { try { r.focus({ preventScroll: true }); } catch (_) { r.focus(); } }
      });
    }
    openLightbox(slideIdx, trigger) {
      if (!this.lb || !this.lb.list.length) return;
      const slide = this.g.slides[slideIdx];
      let pos = this.lb.list.indexOf(slide);
      if (pos < 0) return;
      this.lb.ret = trigger || document.activeElement;
      this.lbShow(pos);
      openDialog(this.lb.el);
      this.overlay('lightbox', true);
    }
    lbShow(pos) {
      const L = this.lb, n = L.list.length;
      if (!n) return;
      pos = ((pos % n) + n) % n;
      L.pos = pos;
      const slide = L.list[pos];
      const src = slide.getAttribute('data-zoom');
      const thumb = $(slide, '.emx-gallery__img');
      this.lbZoom(false);
      if (L.img && src) { L.img.src = src; L.img.alt = thumb ? thumb.alt : ''; }
      setText(L.count, (pos + 1) + ' / ' + n);
      /* 200% zoom only for images at least 1200px wide (data-zoom-in); smaller ones show at natural size. */
      const zin = slide.hasAttribute('data-zoom-in');
      L.el.classList.toggle('is-nozoom', !zin);
      if (L.zoomBtn) show(L.zoomBtn, zin);
    }
    lbZoom(z, px, py) {
      const L = this.lb;
      if (!L) return;
      L.el.classList.toggle('is-zoomed', !!z);
      if (L.zoomBtn) {
        L.zoomBtn.setAttribute('aria-pressed', z ? 'true' : 'false');
        L.zoomBtn.setAttribute('aria-label', z ? 'Zoom out' : 'Zoom in');
      }
      const img = L.img, wrap = L.wrap;
      if (z && wrap && img) requestAnimationFrame(() => {
        wrap.scrollLeft = Math.max(0, (px == null ? 0.5 : px) * img.offsetWidth - wrap.clientWidth / 2);
        wrap.scrollTop = Math.max(0, (py == null ? 0.5 : py) * img.offsetHeight - wrap.clientHeight / 2);
      });
    }

    /* ---------- Options / variant resolution ---------- */
    m_options() {
      this.radios = $$(this, 'input[type="radio"][data-emx-oi]');
      /* Virtual facets (Colour + Thickness pills standing in for one long option list) */
      const fr = $$(this, 'input[type="radio"][data-emx-facet]');
      this.fac = null;
      if (fr.length) {
        const map = {}, vals = {};
        this.radios.forEach((r) => {
          const c = r.getAttribute('data-emx-fc'), t = r.getAttribute('data-emx-ft');
          if (c == null || t == null) return;
          map[c + '|' + t] = r.value;
          vals[r.value] = { c, t };
        });
        this.fac = { radios: fr, map, vals, oi: Number(fr[0].getAttribute('data-emx-foi')) || 0 };
      }
      this.on(this, 'change', (e) => {
        const t = e.target;
        if (!t || !t.matches) return;
        if (t.matches('input[data-emx-facet]')) this.pickFacet(t.getAttribute('data-emx-facet'), t.value, t);
        else if (t.matches('input[data-emx-oi]')) this.pick(Number(t.getAttribute('data-emx-oi')), t.value);
        else if (t.matches('select[data-emx-idselect]') && !this._committing) {
          const v = this.byId(t.value);
          if (v) { this.state.sel = v.o.slice(); this.commit(v, true); }
        }
      });
      $$(this, '[data-emx-filter]').forEach((inp) => {
        this.on(inp, 'input', () => this.filterList(inp));
        this.on(inp, 'keydown', (e) => { if (e.key === 'Enter') e.preventDefault(); });
      });
    }
    filterList(inp) {
      const fs = inp.closest('.emx-opt');
      if (!fs) return;
      const rows = $$(fs, '[data-emx-row]');
      const tokens = inp.value.toLowerCase().split(/\s+/).filter(Boolean);
      let matches = 0;
      rows.forEach((row) => {
        const radio = $(row, 'input');
        const label = (row.getAttribute('data-label') || '').toLowerCase();
        const hit = tokens.every((tk) => label.indexOf(tk) !== -1);
        if (hit) matches++;
        row.hidden = !(hit || (radio && radio.checked));
      });
      setText($(fs, '[data-emx-filter-count]'), tokens.length ? matches + ' of ' + rows.length + ' shown' : '');
      show($(fs, '[data-emx-filter-empty]'), tokens.length > 0 && matches === 0);
    }
    candidate(i, x, sel) {
      return this.usable.find((v) => v.o[i] === x && v.o.every((y, j) => j === i || y === sel[j])) || null;
    }
    pick(i, x) {
      const sel = this.state.sel.slice();
      const old = sel.slice();
      sel[i] = x;
      let v = this.usable.find((c) => c.o.every((y, j) => y === sel[j]));
      let note = '';
      if (!v) {
        const pool = this.usable.filter((c) => c.o[i] === x);
        /* Fallback ranking: exact matches of the other options first, then values that keep the shopper's
           colour (same text before " - ", else the same first word: "Red - Smooth Texture" -> "Red - Raised
           Disk"), then availability; catalogue order only breaks remaining ties. */
        const head = (s) => { s = String(s == null ? '' : s).toLowerCase(); return (s.indexOf(' - ') > -1 ? s.split(' - ')[0] : s.split(/\s+/)[0]).trim(); };
        let best = null, bestScore = -1;
        pool.forEach((c) => {
          let m = 0, sim = 0;
          c.o.forEach((y, j) => {
            if (j === i) return;
            if (y === sel[j]) m++;
            else if (head(y) && head(y) === head(sel[j])) sim++;
          });
          const score = 8 * m + 2 * sim + (c.a ? 1 : 0);
          if (score > bestScore) { best = c; bestScore = score; }
        });
        v = best;
        if (v) {
          const changes = [];
          v.o.forEach((y, j) => { if (j !== i && y !== old[j]) changes.push(lbl(old[j]) + ' isn\'t available with ' + lbl(x) + ' – switched to ' + lbl(y)); });
          note = changes.join('. ');
        }
      }
      if (!v) return;
      this.state.sel = v.o.slice();
      this.commit(v, true);
      if (note) {
        this.announce(note, true);
        this.optNote(note, $(this, '.emx-opt[data-emx-opt="' + i + '"]'));
        this.scrollLists();
      }
    }
    pickFacet(kind, val, input) {
      const F = this.fac;
      if (!F) return;
      const cur = F.vals[this.state.sel[F.oi]] || {};
      const c = kind === 'c' ? val : cur.c, t = kind === 't' ? val : cur.t;
      let x = F.map[c + '|' + t];
      let note = '';
      if (!x) {
        const tn = (s) => parseFloat(s) || 0;
        let best = null, bd = Infinity;
        Object.keys(F.vals).forEach((k) => {
          const o = F.vals[k];
          if (kind === 'c' ? o.c !== c : o.t !== t) return;
          const vv = this.usable.find((w) => w.o[F.oi] === k);
          const d = kind === 'c' ? Math.abs(tn(o.t) - tn(cur.t)) : (o.c === cur.c ? 0 : 1);
          const score = d + (vv && vv.a ? 0 : 1000);
          if (score < bd) { bd = score; best = k; }
        });
        x = best;
        if (x) {
          const o = F.vals[x];
          note = kind === 'c' ? cur.t + ' isn\'t available in ' + c + ' – switched to ' + o.t : cur.c + ' isn\'t available in ' + t + ' – switched to ' + o.c;
        }
      }
      if (!x) return;
      this.pick(F.oi, x);
      if (note) {
        this.announce(note, true);
        this.optNote(note, input ? input.closest('.emx-opt') : null);
      }
    }
    /* Visible explanation when a choice forces another option to change (screen readers get announce()). */
    optNote(msg, fs) {
      fs = fs || $(this, '.emx-opt:not([hidden])');
      if (!fs || !msg) return;
      let n = $(fs, '[data-emx-optnote]');
      if (!n) {
        n = document.createElement('p');
        n.className = 'emx-opt__note';
        n.setAttribute('data-emx-optnote', '');
        n.setAttribute('aria-hidden', 'true');
        fs.appendChild(n);
      }
      n.textContent = msg + '.';
      n.hidden = false;
      /* No timer: the note stays until the next option change (commit() clears it). */
    }
    /* Keep the checked row of each scrolling option list in view (only the list scrolls, never the page). */
    scrollLists() {
      $$(this, '.emx-optlist').forEach((list) => {
        if (!list.offsetParent || list.scrollHeight <= list.clientHeight + 2) return;
        const r = $(list, 'input:checked');
        const row = r ? (r.closest('[data-emx-row]') || r.nextElementSibling) : null;
        if (!row || row.hidden) return;
        const lr = list.getBoundingClientRect(), rr = row.getBoundingClientRect();
        const top = rr.top - lr.top + list.scrollTop;
        if (rr.top >= lr.top && rr.bottom <= lr.bottom) return;
        list.scrollTop = Math.max(0, top - (list.clientHeight - row.offsetHeight) / 2);
      });
    }
    toThemeVariant(v) {
      if (!v) return null;
      const o = v.o || [];
      return {
        id: v.id, title: v.t, option1: o[0] || null, option2: o[1] || null, option3: o[2] || null, options: o,
        price: v.p, compare_at_price: v.c, available: v.a, sku: v.s, featured_media: v.m ? { id: v.m } : null,
        quantity_rule: { min: v.q[0], increment: v.q[1], max: v.q[2] }, requires_shipping: true, taxable: v.tx
      };
    }
    commit(v, userInitiated) {
      const prev = this.state.variant;
      const form = this.form;
      if (form && this.idCtrl) {
        this._committing = true;
        try {
          this.idCtrl.value = v.id;
          this.idCtrl.dispatchEvent(new Event('change', { bubbles: true }));
        } finally { this._committing = false; }
      }
      if (userInitiated) {
        try {
          const u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({ path: u.toString() }, '', u.toString());
        } catch (e) { warn(e); }
      }
      if (form) {
        const detail = { formId: form.getAttribute('id'), variant: this.toThemeVariant(v), previousVariant: prev ? this.toThemeVariant(prev) : null };
        form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail }));
        form.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail }));
      }
      this.state.variant = v;
      /* A cut list is a plan for one roll width: keep it when only colour/thickness change (same width),
         drop it - visibly - when the width changes. */
      let cutDropped = false;
      if (prev !== v && this.state.cut) {
        const wp = prev ? this.unitDims(prev).W : null, wn = this.unitDims(v).W;
        if (!wp || !wn || Math.abs(wp - wn) > 1e-6) { this.state.cut = null; cutDropped = true; }
      }
      $$(this, '[data-emx-optnote]').forEach((n) => { n.hidden = true; });
      this.hideQtyMsg();
      this.hideError();
      /* A new option can have a lower stock limit (or a higher minimum): say so when the quantity changes,
         and drop - visibly - a cut list that no longer matches the length. */
      const q0 = this.state.qty;
      this.clampQty(false);
      const msgs = [];
      if (q0 > 0 && this.state.qty !== q0) {
        const what = this.metre ? 'Length' : 'Quantity';
        msgs.push(what + ' changed to ' + this.qtyText() + (this.state.qty < q0 ? ' – the most available in this option.' : ' – the minimum for this option.'));
      }
      if (!cutDropped && this.state.cut && this.state.cut.qty !== this.state.qty) {
        this.state.cut = null;
        msgs.push('Cut list removed because the length changed. Press Use again in "How much do I need?"');
      } else if (cutDropped) msgs.push('Cut list removed because the width changed. Press Use again in "How much do I need?"');
      this.render();
      if (v.m) this.goToMedia(v.m);
      else if (prev && prev.m && prev !== v) this.goToGeneralMedia();
      if (msgs.length) {
        const msg = msgs.join(' ');
        this.qtyMsg(msg);
        this.announce(msg, true);
      } else this.announce();
    }
    /* A variant with no image of its own: show the product's general (non-variant) image rather than leaving
       another colour's photo on screen. Stays put when every image belongs to a variant. */
    goToGeneralMedia() {
      if (!this.g) return;
      const own = {};
      this.V.forEach((x) => { if (x.m) own[String(x.m)] = true; });
      const i = this.g.slides.findIndex((s) => !own[String(s.getAttribute('data-media-id'))] && s.classList.contains('emx-gallery__slide--image'));
      if (i >= 0 && i !== this.g.idx) this.goTo(i, false);
    }
    rOptions() {
      const sel = this.state.sel;
      const mono = {};
      (this.radios || []).forEach((r) => {
        const i = Number(r.getAttribute('data-emx-oi')), x = r.value;
        const cand = this.candidate(i, x, sel);
        const st = !cand ? 'unavailable' : (!cand.a ? 'soldout' : 'ok');
        const want = sel[i] === x;
        if (r.checked !== want) r.checked = want;
        const lab = r.nextElementSibling;
        if (!lab) return;
        lab.classList.toggle('is-unavailable', st === 'unavailable');
        lab.classList.toggle('is-soldout', st === 'soldout');
        setText($(lab, '[data-emx-state]'), st === 'unavailable' ? ' – not available in this combination' : st === 'soldout' ? ' – sold out' : '');
        const pe = $(lab, '[data-emx-vprice]');
        if (pe) (mono[i] = mono[i] || []).push({ n: lead(($(lab, '.emx-choice__text') || {}).textContent), p: cand ? cand.p : null });
        if (pe) {
          let pv = cand;
          if (!pv) {
            const pool = this.usable.filter((c) => c.o[i] === x);
            pv = pool.sort((a, b) => a.p - b.p)[0];
          }
          if (pv) setText(pe, this.fmt(this.disp(pv, pv.p)) + (this.metre ? '/m' : ''));
        }
      });
      $$(this, '[data-emx-opt]').forEach((fs) => {
        const i = Number(fs.getAttribute('data-emx-opt'));
        /* Legend repeats the value as the pill / row shows it; the full label stays in the pill's
           data-emx-full attribute (not a title, so it is never announced) and in the Specifications table. */
        const cr = sel[i] != null ? this.radioFor(i, sel[i]) : null;
        const cl = cr && cr.nextElementSibling;
        const ct = cl ? (($(cl, '.emx-choice__text') || {}).textContent || cl.getAttribute('data-emx-full') || '') : '';
        setText($(fs, '[data-emx-current]'), sel[i] != null ? ': ' + (ct.trim() || lbl(sel[i])) : '');
        const f = $(fs, '[data-emx-filter]');
        if (f && f.value) this.filterList(f);
        /* Per-value prices are hidden where a larger size costs less than a smaller one (catalogue errors). */
        if (mono[i]) fs.classList.toggle('emx-opt--noprice', nonMono(mono[i]));
      });
      const F = this.fac;
      if (F) {
        const cur = F.vals[sel[F.oi]] || {};
        F.radios.forEach((r) => {
          const kind = r.getAttribute('data-emx-facet');
          const want = kind === 'c' ? r.value === cur.c : r.value === cur.t;
          if (r.checked !== want) r.checked = want;
          const x = kind === 'c' ? F.map[r.value + '|' + cur.t] : F.map[cur.c + '|' + r.value];
          const vv = x != null ? this.usable.find((w) => w.o[F.oi] === x) : null;
          const st = !vv ? 'unavailable' : (!vv.a ? 'soldout' : 'ok');
          const lab = r.nextElementSibling;
          if (!lab) return;
          lab.classList.toggle('is-unavailable', st === 'unavailable');
          lab.classList.toggle('is-soldout', st === 'soldout');
          setText($(lab, '[data-emx-state]'), st === 'unavailable' ? ' – not available in this combination' : st === 'soldout' ? ' – sold out' : '');
          const pe = $(lab, '[data-emx-vprice]');
          if (pe) setText(pe, vv ? this.fmt(this.disp(vv, vv.p)) + (this.metre ? '/m' : '') : '');
          if (pe && kind === 't') (mono.t = mono.t || []).push({ n: lead(r.value), p: vv ? vv.p : null });
        });
        const tg = $(this, '[data-emx-fgroup="t"]');
        if (tg && mono.t) tg.classList.toggle('emx-opt--noprice', nonMono(mono.t));
        $$(this, '[data-emx-fcur]').forEach((el) => {
          const k = el.getAttribute('data-emx-fcur');
          setText(el, cur[k] ? ': ' + cur[k] : '');
        });
      }
      /* Owner-approved thickness hints (product metafield custom.thickness_guide): show the selected one. */
      $$(this, '[data-emx-thints]').forEach((box) => {
        const k = box.getAttribute('data-emx-thints');
        let cv = '';
        if (k === 't') cv = F ? ((F.vals[sel[F.oi]] || {}).t || '') : '';
        else cv = sel[Number(k)] != null ? String(sel[Number(k)]) : '';
        const norm = (s) => String(s || '').toLowerCase().replace(/\s+/g, '');
        let any = false;
        $$(box, '[data-emx-thint-for]').forEach((el) => {
          const on = norm(el.getAttribute('data-emx-thint-for')) === norm(cv);
          show(el, on);
          if (on) any = true;
        });
        show(box, any);
      });
    }

    /* ---------- Price ---------- */
    unitDims(v) {
      if (!v) return { L: null, W: null };
      const src = v.t && v.t !== 'Default Title' ? v.t : this.d.full;
      const r = dims(src);
      const wo = Number(this.d.widthOption);
      if (wo >= 0 && v.o && v.o[wo] != null) {
        const m = String(v.o[wo]).match(RX.one);
        const w = m ? toM(m[1], m[2]) : null;
        if (w) r.W = w;
      }
      return r;
    }
    rPrice() {
      const v = this.state.variant;
      const box = $(this, '[data-emx-price]');
      if (!v || !box) return;
      const inc = v.p, ex = this.exVat(v, v.p);
      if (this.d.taxExempt) {
        setText($(box, '[data-emx-amount]'), this.fmt(ex));
        setText($(box, '[data-emx-vatlabel]'), 'ex VAT');
        setText($(box, '[data-emx-exvat]'), this.fmt(inc) + ' inc VAT');
      } else {
        setText($(box, '[data-emx-amount]'), this.fmt(inc));
        setText($(box, '[data-emx-vatlabel]'), 'inc. VAT');
        setText($(box, '[data-emx-exvat]'), this.fmt(ex) + ' ex VAT');
      }
      const hasC = v.c != null && v.c > v.p;
      show($(box, '[data-emx-was]'), hasC);
      show($(box, '[data-emx-save]'), hasC);
      if (hasC) {
        setText($(box, '[data-emx-was-amt]'), this.fmt(v.c));
        setText($(box, '[data-emx-save]'), 'Save ' + this.fmt(v.c - v.p));
      }
      const ul = $(box, '[data-emx-unitline]');
      if (ul) {
        const { L, W } = this.unitDims(v);
        const p = this.disp(v, v.p);
        let t = '';
        if (this.metre && W) t = this.fmt(Math.round(p / W)) + ' per m²';
        else if (L && W && W >= 0.1) t = 'covers ' + t2(L * W) + ' m² (' + t2(L) + ' m × ' + t2(W) + ' m) · ' + this.fmt(Math.round(p / (L * W))) + ' per m²';
        const ex2 = $(box, '[data-emx-exvat]');
        setText(ul, t ? (ex2 ? ' · ' : '') + t : '');
      }
    }
    announce(extra, now) {
      const el = $(this, '[data-emx-announce]');
      if (!el) return;
      clearTimeout(this._annT);
      const run = () => {
        try {
          const v = this.state.variant;
          if (!v) return;
          const t = this.totals();
          let msg = this.fmt(this.disp(v, v.p)) + (this.metre ? ' per metre' : '') + (this.d.taxExempt ? ' ex VAT' : ' inc. VAT');
          if (t.visible) msg += '. Total ' + this.fmt(this.d.taxExempt ? t.ex : t.inc);
          if (!v.a) msg += '. Sold out';
          if (extra) msg = extra + '. ' + msg;
          el.textContent = msg;
        } catch (e) { warn(e); }
      };
      if (now) run(); else this._annT = setTimeout(run, 250);
    }

    /* ---------- Buy: quantity, total, submit ---------- */
    m_buy() {
      if (!this.form) return;
      this.qtyInput = $(this.form, '[data-emx-qty-input]');
      this.atc = $(this.form, '[data-emx-atc]');
      /* The express-checkout block is never wider than Add to basket: on wider screens, where the quantity
         shares the button's row, it sits under the button at the button's width (--emx-atc-w, CSS). */
      if (this.atc && $(this.form, '[data-emx-dyn]') && 'ResizeObserver' in window) {
        const setW = () => { const w = this.atc.offsetWidth; if (w > 0) this.form.style.setProperty('--emx-atc-w', w + 'px'); };
        const ro = new ResizeObserver(setW);
        ro.observe(this.atc);
        this._obs.push(ro);
        setW();
      }
      if (this.qtyInput) this.state.qty = parseInt(this.qtyInput.value, 10) || 0;
      this.on(this.form, 'submit', (e) => { e.preventDefault(); this.submitMain(this.atc); });
      this.on(this, 'click', (e) => {
        const b = e.target.closest && e.target.closest('[data-emx-step]');
        if (!b || !this.contains(b) || b.disabled) return;
        const box = b.closest('[data-emx-qty]');
        const inp = $(box, 'input[type="number"]');
        if (!inp || inp.disabled) return;
        const dir = Number(b.getAttribute('data-emx-step')) || 0;
        const step = Number(inp.step) || 1;
        const min = inp.min !== '' ? Number(inp.min) : 0;
        const max = inp.max !== '' ? Number(inp.max) : Infinity;
        const cur = num(inp.value);
        let n = (isFinite(cur) ? (dir > 0 ? Math.floor(cur + EPS) : up(cur)) : 0) + dir * step;
        n = Math.min(max, Math.max(min, n));
        if (inp === this.qtyInput) this.hideQtyMsg();
        inp.value = n;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (this.qtyInput) {
        this.on(this.qtyInput, 'input', () => {
          this.hideQtyMsg();
          this.hideError();
          const raw = num(this.qtyInput.value);
          /* Live total while typing: decimals count as the next whole unit (we never sell less than asked for). */
          if (isFinite(raw) && raw >= 0) { this.state.qty = up(raw); this.rCut(); this.rBuy(); this.rSticky(); this.rHelp(); }
        });
        this.on(this.qtyInput, 'change', () => { this.clampQty(true); this.render(); this.announce(); });
        this.on(this.qtyInput, 'blur', () => { this.clampQty(true); this.render(); });
      }
      this.on($(this.form, '[data-emx-cut-remove]'), 'click', () => {
        this.state.cut = null;
        this.render();
        try { this.qtyInput.focus({ preventScroll: true }); } catch (_) { /* noop */ }
      });
    }
    /* The quantity message is a status region that stays in the DOM (never display:none), so text written
       into it is announced reliably; it is cleared on the next change instead of on a timer. */
    qtyMsg(msg) { const m = $(this, '[data-emx-qty-msg]'); if (m) { show(m, true); setText(m, msg || ''); } }
    hideQtyMsg() { this.qtyMsg(''); }
    hideError() { const e = $(this, '[data-emx-error]'); if (e && !e.hidden) e.hidden = true; }
    limits() {
      const v = this.state.variant;
      const q = v && v.q ? v.q : [1, 1, null];
      const min = this.anyAcc() ? 0 : (Number(q[0]) || 1);
      const inc = Number(q[1]) || 1;
      let max = Infinity;
      if (q[2] != null) max = Math.min(max, Number(q[2]));
      if (v && v.mx != null) max = Math.min(max, Math.max(0, Number(v.mx)));
      return { min, inc, max };
    }
    clampQty(fromUser) {
      const inp = this.qtyInput;
      if (!inp) return;
      const { min, inc, max } = this.limits();
      const raw = num(inp.value);
      let n = isFinite(raw) ? up(raw) : min;
      let msg = '';
      /* Decimals are rounded UP (cut-to-order goods: never sell less than the customer asked for). */
      if (isFinite(raw) && raw > 0 && Math.abs(n - raw) > EPS) msg = this.metre ? 'Rounded up to ' + n + ' m – we cut in whole metres.' : 'Rounded up to ' + n + ' – whole numbers only.';
      if (n < min) n = min;
      if (inc > 1 && n > min) { const n2 = min + up((n - min) / inc) * inc; if (n2 !== n) { n = n2; msg = 'Rounded up to ' + this.qtyText(n) + ' – sold in multiples of ' + inc + '.'; } }
      if (max !== Infinity && max > 0 && n > max) { n = max; msg = 'Maximum ' + max + ' available to order online. For more, request a quote.'; }
      if (String(n) !== inp.value) inp.value = n;
      inp.min = min;
      inp.step = inc;
      if (max !== Infinity && max > 0) inp.max = max; else inp.removeAttribute('max');
      this.state.qty = n;
      if (fromUser && msg) this.qtyMsg(msg);
    }
    totals() {
      const v = this.state.variant;
      const items = [];
      if (v && v.a && this.state.qty > 0) items.push({ v, quantity: this.state.qty });
      Object.keys(this.state.acc).forEach((id) => {
        const n = this.state.acc[id];
        const av = this.byId(id);
        if (av && av.a && n > 0) items.push({ v: av, quantity: n });
      });
      let inc = 0, ex = 0;
      items.forEach((it) => { const line = it.v.p * it.quantity; inc += line; ex += this.exVat(it.v, line); });
      const visible = this.metre || this.state.qty > 1 || this.anyAcc();
      /* The separate "Total" line only adds information beyond the button label once the quantity is above
         the minimum, a cut list is set, or add-ons are chosen. */
      const lim = this.limits();
      const line = this.state.qty > Math.max(1, lim.min) || !!this.state.cut || this.anyAcc();
      return { items, inc, ex, visible, line };
    }
    rBuy() {
      const v = this.state.variant;
      const form = this.form;
      if (!form) return;
      const off = !v || !v.a;
      const acc = this.anyAcc();
      form.classList.toggle('emx-buy--off', off);
      const t = this.totals();
      const totalEl = $(form, '[data-emx-total]');
      const amt = this.d.taxExempt ? t.ex : t.inc;
      if (totalEl) {
        setText(totalEl, this.d.taxExempt
          ? 'Total ' + this.fmt(t.ex) + ' ex VAT (' + this.fmt(t.inc) + ' inc VAT)'
          : 'Total ' + this.fmt(t.inc) + ' inc VAT (' + this.fmt(t.ex) + ' ex VAT)');
        show(totalEl, t.line && t.items.length > 0);
      }
      const label = !v ? 'Unavailable' : (!v.a && !acc ? 'Sold out' : 'Add to basket');
      if (this.atc && !this._flash) {
        setText($(this.atc, '[data-emx-atc-label]'), label);
        setText($(this.atc, '[data-emx-atc-total]'), t.visible && t.items.length ? ' · ' + this.fmt(amt) : '');
      }
      if (this.atc && !this._busy) this.atc.disabled = off && !acc;
      /* Express checkout skips our add-ons and cut list, so hide it while either is in use,
         and never offer it for a sold-out or unavailable variant. */
      const cut = !!this.state.cut;
      const dyn = $(form, '[data-emx-dyn]');
      if (dyn) show(dyn, !off && !acc && !cut);
      const dn = $(form, '[data-emx-dyn-note]');
      if (dn) {
        setText(dn, cut ? 'Use Add to basket to keep your cut list.' : 'Use Add to basket to include edging.');
        show(dn, !off && (acc || cut) && !!dyn);
      }
      const live = $(form, '[data-emx-live]');
      if (live) {
        const { W } = this.unitDims(v);
        const q = this.state.qty;
        setText(live, W ? q + ' m × ' + t2(W) + ' m = ' + t2(q * W) + ' m²' : q + ' m');
      }
    }
    /* Cut list chosen in the metre calculator: shown as a chip and sent as a line-item property. */
    rCut() {
      const box = $(this, '[data-emx-cut]');
      const c = this.state.cut;
      if (c && c.qty !== this.state.qty) this.state.cut = null;
      const on = !!this.state.cut;
      if (!box) return;
      show(box, on);
      setText($(box, '[data-emx-cut-text]'), on ? 'We\'ll cut this into ' + this.cutProp(this.state.cut) : '');
      const inp = $(box, '[data-emx-cut-input]');
      if (inp) { inp.value = on ? this.cutProp(this.state.cut) : ''; inp.disabled = !on; }
    }
    /* Line-item property text: states the total it covers, so a basket quantity change is visibly inconsistent. */
    cutProp(c) { return c ? c.text + ' (' + c.qty + ' m total)' : ''; }
    rSku() {
      const v = this.state.variant;
      const sku = v && v.s ? v.s : '';
      $$(this, '[data-emx-sku]').forEach((el) => setText(el, sku));
      show($(this, '[data-emx-sku-wrap]'), !!sku);
      const row = $(this, '[data-emx-spec-sku]');
      if (row) { show(row, !!sku); setText($(row, '[data-emx-spec-sku-val]'), sku); }
      if (v) $$(this, '[data-emx-spec-opt]').forEach((td) => {
        const i = Number(td.getAttribute('data-emx-spec-opt'));
        /* Relabelled options (e.g. Size -> Colour) show the short value; the shared part has its own row. */
        const g = td.hasAttribute('data-emx-spec-short') && Array.isArray(this.d.dd) ? this.d.dd[i] : null;
        if (g && g.s && g.s[v.o[i]] != null) { setText(td, g.s[v.o[i]]); return; }
        const r = this.radioFor(i, v.o[i]);
        const l = r && r.nextElementSibling;
        const t = l ? (l.getAttribute('data-emx-full') || ($(l, '.emx-choice__text') || {}).textContent || '') : '';
        setText(td, t.trim() || lbl(v.o[i]));
      });
    }
    /* Errors stay visible until the next change (no timer), so slow readers are not rushed. */
    showError(msg, el) {
      el = el || $(this, '[data-emx-error]');
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
    }
    /* The sticky bar only shows once the buy box is off-screen, so a message raised from it would be
       invisible: bring the message (and the buy box) into view and move focus there. */
    revealMain(el, btn) {
      if (!el || !btn || !btn.closest || !btn.closest('[data-emx-sticky]')) return;
      try { el.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' }); } catch (_) { el.scrollIntoView(); }
      const f = this.qtyInput && !this.qtyInput.disabled ? this.qtyInput : this.atc;
      if (f) { try { f.focus({ preventScroll: true }); } catch (_) { /* noop */ } }
    }
    submitMain(btn) {
      if (this._busy) return;
      this.hideError();
      this.clampQty(true);
      this.render();
      const v = this.state.variant;
      const t = this.totals();
      if (!t.items.length) {
        this.showError(v && !v.a ? 'This option is sold out.' : 'Choose a quantity');
        this.revealMain($(this, '[data-emx-error]'), btn);
        return;
      }
      const cut = this.state.cut;
      const ref = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      const items = t.items.map((it) => {
        const props = cut && it.v === v ? { [CUT_PROP]: this.cutProp(cut), [CUT_REF]: ref } : null;
        return this.itemMeta(it.v, it.quantity, props ? { props } : null);
      });
      this.addItems(items, btn || this.atc, { flash: true });
    }
    itemMeta(v, quantity, extra) {
      const isAcc = !!v.acc;
      return Object.assign({
        id: v.id, quantity, title: this.d.title, option: this.optText(v),
        img: (this.d.img || {})[v.id] || null, price: this.disp(v, v.p), metre: this.metre && !isAcc
      }, extra || {});
    }
    async addItems(items, btn, opts) {
      opts = opts || {};
      if (this._busy || !items.length) return false;
      this._busy = true;
      const errEl = opts.errorEl;
      /* aria-disabled (not disabled) while busy, so keyboard focus is not dropped to <body>;
         repeat clicks are ignored by the _busy guard. */
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.setAttribute('aria-busy', 'true'); }
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      const base = (window.routes && window.routes.cartAddUrl) || '/cart/add';
      let res = null, data = {};
      try {
        res = await fetch(base + '.js', {
          method: 'POST', credentials: 'same-origin', signal: this.signal(),
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items.map((i) => (i.props ? { id: i.id, quantity: i.quantity, properties: i.props } : { id: i.id, quantity: i.quantity })) })
        });
        try { data = await res.json(); } catch (_) { data = {}; }
      } catch (e) {
        if (e && e.name === 'AbortError') return false;
        warn(e);
        res = null;
      } finally {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        this._busy = false;
        if (btn) { btn.removeAttribute('aria-busy'); btn.removeAttribute('aria-disabled'); }
        try { this.rBuy(); this.rSticky(); this.rFbt(); } catch (e) { warn(e); }
      }
      if (!res || !res.ok) {
        this.showError((data && (data.description || data.message)) || 'Sorry, we couldn\'t add that to your basket. Please try again.', errEl);
        this.revealMain(errEl || $(this, '[data-emx-error]'), btn);
        return false;
      }
      const errBox = errEl || $(this, '[data-emx-error]');
      if (errBox) errBox.hidden = true;
      if (opts.flash) this.flashAdded();
      await this.afterAdd(items, data, btn);
      return true;
    }
    flashAdded() {
      if (!this.atc) return;
      this._flash = true;
      this.atc.classList.add('is-added');
      setText($(this.atc, '[data-emx-atc-label]'), 'Added');
      setText($(this.atc, '[data-emx-atc-total]'), '');
      this.later(() => { this._flash = false; this.atc.classList.remove('is-added'); this.rBuy(); this.rSticky(); }, 1500);
    }
    async afterAdd(items, data, btn) {
      const mode = this.d.atc || 'panel';
      const cartUrl = (window.routes && window.routes.cartUrl) || '/cart';
      if (mode === 'cart') { window.location.href = cartUrl; return; }
      if (mode === 'theme') {
        const qty = items.reduce((a, i) => a + Number(i.quantity || 0), 0);
        const target = this.form || this;
        target.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: data && data.items ? data.items[0] : data, button: btn, quantity: qty } }));
        document.dispatchEvent(new CustomEvent('modal:close'));
        return;
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
      let cart = null;
      try {
        const r = await fetch(cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: this.signal() });
        if (r.ok) cart = await r.json();
      } catch (e) { if (!(e && e.name === 'AbortError')) warn(e); }
      this.openAdded(items, data, cart, btn);
    }

    /* ---------- Accessories (edging / corners) ---------- */
    m_acc() {
      const box = $(this, '[data-emx-accs]');
      if (!box) return;
      this.on(box, 'change', (e) => {
        const inp = e.target.closest && e.target.closest('input[data-emx-acc]');
        if (!inp) return;
        let n = up(num(inp.value));
        if (!isFinite(n) || n < 0) n = 0;
        if (String(n) !== inp.value) inp.value = n;
        this.state.acc[inp.getAttribute('data-emx-acc')] = n;
        this.clampQty(false);
        this.render();
        this.announce();
      });
    }

    /* ---------- Calculators ---------- */
    m_calc() {
      this.calc = { box: $(this, '[data-emx-calc]'), link: $(this, '[data-emx-calc-toggle]') };
      const c = this.calc;
      if (!c.box) return;
      c.panel = $(c.box, '[data-emx-calc-type]');
      c.type = c.panel ? c.panel.getAttribute('data-emx-calc-type') : null;
      if (!c.panel) return;
      c.key = 'emx-calc-' + c.type;
      const cin = (k) => $(c.panel, '[data-emx-cin="' + k + '"]');
      const saved = store.get(c.key);
      if (saved) {
        const only = saved.mode === 'area' ? ['A'] : saved.mode === 'lw' ? ['L', 'W'] : null;
        $$(c.panel, '[data-emx-cin]').forEach((i) => {
          const k = i.getAttribute('data-emx-cin');
          if (only && only.indexOf(k) === -1) return;
          if (saved[k] != null && saved[k] !== '') i.value = saved[k];
        });
        if (saved.unit === 'ft') { const f = $(c.panel, 'input[data-emx-cunit][value="ft"]'); if (f) f.checked = true; }
      }
      const uSel = $(c.panel, 'input[data-emx-cunit]:checked');
      c.unit = uSel && uSel.value === 'ft' ? 'ft' : 'm';
      this.on(c.link, 'click', () => {
        const open = c.box.hidden;
        c.box.hidden = !open;
        c.link.setAttribute('aria-expanded', String(open));
        if (open) { const f = $(c.panel, 'input[data-emx-cin]'); if (f) { try { f.focus({ preventScroll: false }); } catch (_) { f.focus(); } } }
      });
      this.on(c.panel, 'input', (e) => {
        const k = e.target && e.target.getAttribute ? e.target.getAttribute('data-emx-cin') : null;
        /* Adhesive: area OR length x width - whichever was typed last wins. */
        if (c.type === 'adhesive' && k && e.target.value !== '') {
          if (k === 'A') { ['L', 'W'].forEach((x) => { const i = cin(x); if (i) i.value = ''; }); c.mode = 'area'; }
          else { const a = cin('A'); if (a) a.value = ''; c.mode = 'lw'; }
        }
        this.rCalc();
      });
      this.on(c.panel, 'change', (e) => {
        const t = e.target;
        /* Units switch: convert what was typed instead of re-reading it in the new unit. */
        if (t && t.matches && t.matches('input[data-emx-cunit]') && t.checked && t.value !== c.unit) {
          /* Keep the exact size in metres so a rounded display (10 ft = 3.05 m) never adds a row of tiles. */
          c.exact = c.exact || {};
          ['L', 'W'].forEach((x) => {
            const i = cin(x);
            const n = i ? num(i.value) : NaN;
            if (!i || !(n > 0)) return;
            const ex = c.exact[x];
            const m = ex && ex.shown === i.value ? ex.m : (c.unit === 'ft' ? n * 0.3048 : n);
            const shown = t2(t.value === 'ft' ? m / 0.3048 : m);
            i.value = shown;
            c.exact[x] = { m, shown };
          });
          c.unit = t.value;
        }
        this.rCalc();
      });
      this.on(c.panel, 'keydown', (e) => { if (e.key === 'Enter' && e.target.matches && e.target.matches('input')) { e.preventDefault(); this.rCalc(); } });
      this.on($(c.panel, '[data-emx-cuse]'), 'click', () => {
        const n = c.useQty;
        if (!n || !this.qtyInput) return;
        this.qtyInput.value = n;
        this.hideQtyMsg();
        this.clampQty(true);
        this.state.cut = c.cutPlan && this.state.qty === n ? { text: c.cutPlan, qty: n } : null;
        this.render();
        this.announce(this.state.cut ? 'Cut list added: ' + c.cutPlan : '');
        try { this.qtyInput.focus(); } catch (_) { /* noop */ }
      });
      this.on($(c.panel, '[data-emx-cadd]'), 'click', (e) => {
        const items = c.glueItems || [];
        if (items.length) this.addItems(items, e.currentTarget, {});
      });
      this.on($(c.panel, '[data-emx-goto-acc]'), 'click', (e) => {
        const acc = $(this, '[data-emx-accs]');
        if (!acc) return;
        e.preventDefault();
        const det = acc.closest('details');
        if (det) det.open = true;
        acc.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
        const f = $(acc, 'input:not([disabled])');
        if (f) { try { f.focus({ preventScroll: true }); } catch (_) { f.focus(); } }
      });
    }
    calcApplies() {
      const c = this.calc;
      if (!c || !c.type) return false;
      const v = this.state.variant;
      if (c.type === 'metre') return !!this.unitDims(v).W;
      if (c.type === 'tiles') {
        /* Never work out a whole room in ramp, corner or edge pieces. */
        if (!v || EDGE_RX.test(String(v.t || ''))) return false;
        const d = this.unitDims(v); return !!(d.L && d.W && d.W >= 0.1 && d.W <= d.L && d.L <= 3.1);
      }
      if (c.type === 'adhesive') return this.V.length > 0 && this.V.every((x) => RX.glue.test(x.t));
      return false;
    }
    rCalc() {
      const c = this.calc;
      if (!c || !c.panel) return;
      const ok = this.calcApplies();
      show(c.link, ok);
      if (!ok) { c.box.hidden = true; if (c.link) c.link.setAttribute('aria-expanded', 'false'); return; }
      const val = (k) => { const i = $(c.panel, '[data-emx-cin="' + k + '"]'); return i ? i.value : ''; };
      const out = $(c.panel, '[data-emx-cout]');
      const use = $(c.panel, '[data-emx-cuse]');
      const v = this.state.variant;
      const put = (parts) => {
        if (!out) return;
        out.textContent = '';
        parts.forEach((p) => {
          if (typeof p === 'string') out.appendChild(document.createTextNode(p));
          else { const s = document.createElement('strong'); s.textContent = p.b; out.appendChild(s); }
        });
      };
      c.useQty = 0;
      c.cutPlan = '';
      if (c.type === 'metre') {
        const L = num(val('L')), Wr = num(val('W')), W = this.unitDims(v).W;
        store.set(c.key, { L: val('L'), W: val('W') });
        if (!(L > 0 && Wr > 0 && W)) { put([]); show(use, false); return; }
        /* Each piece is a whole number of metres (we cut in whole metres). */
        const dA = up(Wr / W), lA = up(L), mA = dA * lA;
        const dB = up(L / W), lB = up(Wr), mB = dB * lB;
        const pickA = mA < mB || (mA === mB && dA <= dB);
        const drops = pickA ? dA : dB, len = pickA ? lA : lB, metres = pickA ? mA : mB;
        put([drops + (drops === 1 ? ' piece' : ' pieces') + ' × ' + len + ' m = ', { b: metres + ' m' }, '. Covers ' + t2(metres * W) + ' m² for your ' + t2(L * Wr) + ' m² room. Total ' + this.fmt(metres * this.disp(v, v.p)) + ' ' + this.vatWord() + '.']);
        c.useQty = metres;
        c.cutPlan = drops > 1 ? drops + ' pieces of ' + len + ' m' : '';
        if (use) { use.textContent = drops > 1 ? 'Use ' + metres + ' m, cut into ' + drops + ' pieces' : 'Use ' + metres + ' m'; use.hidden = false; }
      } else if (c.type === 'tiles') {
        const ftSel = $(c.panel, 'input[data-emx-cunit]:checked');
        const unit = ftSel && ftSel.value === 'ft' ? 'ft' : 'm';
        $$(c.panel, '[data-emx-cunit-label]').forEach((s) => setText(s, unit));
        const f = unit === 'ft' ? 0.3048 : 1;
        const ex = c.exact || {};
        const metres = (k) => (ex[k] && ex[k].shown === val(k) ? ex[k].m : num(val(k)) * f);
        const Lr = metres('L'), Wr = metres('W');
        store.set(c.key, { L: val('L'), W: val('W'), unit });
        const d = this.unitDims(v);
        if (!(Lr > 0 && Wr > 0 && d.L && d.W)) { put([]); show(use, false); return; }
        const l = d.L, w = d.W;
        const aC = up(Lr / l), aR = up(Wr / w), bC = up(Lr / w), bR = up(Wr / l);
        const a = aC * aR, b = bC * bR;
        const n = a <= b ? a : b, cols = a <= b ? aC : bC, rows = a <= b ? aR : bR;
        const word = l >= 1.2 ? (n === 1 ? 'mat' : 'mats') : (n === 1 ? 'tile' : 'tiles');
        const cost = this.fmt(n * this.disp(v, v.p));
        put([{ b: n + ' ' + word }, ' (' + cols + ' × ' + rows + '). Covers ' + t2(n * l * w) + ' m² for your ' + t2(Lr * Wr) + ' m² room. Total ' + cost + ' ' + this.vatWord() + '.']);
        c.useQty = n;
        if (use) { use.textContent = 'Use ' + n + ' ' + word + ' · ' + cost; use.hidden = false; }
      } else if (c.type === 'adhesive') {
        const L = num(val('L')), W = num(val('W'));
        let A = L > 0 && W > 0 ? L * W : num(val('A'));
        const mode = L > 0 || W > 0 ? 'lw' : 'area';
        store.set(c.key, mode === 'lw' ? { mode, L: val('L'), W: val('W') } : { mode, A: val('A') });
        const add = $(c.panel, '[data-emx-cadd]');
        const qw = $(c.panel, '[data-emx-cquote-wrap]');
        c.glueItems = [];
        c.quoteArea = 0;
        show(qw, false);
        if (!(A > 0)) { put([]); show(add, false); return; }
        if (A > 2000) {
          /* Passed to the quote form, so the enquiry carries the area rather than "1 x pack". */
          c.quoteArea = Math.round(A);
          put(['For areas over 2,000 m², please request a quote.']);
          show(add, false);
          show(qw, true);
          return;
        }
        A = up(A);
        const packs = this.V.filter((x) => x.a).map((x) => { const m = x.t.match(RX.glue); return m ? { v: x, kg: Number(m[1]), c: Number(m[2]) } : null; }).filter((p) => p && p.c > 0);
        if (!packs.length) { put(['Sold out']); show(add, false); return; }
        const cost = new Array(A + 1).fill(Infinity), cnt = new Array(A + 1).fill(Infinity), ch = new Array(A + 1).fill(-1);
        cost[0] = 0; cnt[0] = 0;
        for (let x = 1; x <= A; x++) {
          for (let i = 0; i < packs.length; i++) {
            const pv = Math.max(0, x - packs[i].c);
            const cc = cost[pv] + packs[i].v.p, kk = cnt[pv] + 1;
            if (cc < cost[x] || (cc === cost[x] && kk < cnt[x])) { cost[x] = cc; cnt[x] = kk; ch[x] = i; }
          }
        }
        const counts = packs.map(() => 0);
        let x = A, guard = 0;
        while (x > 0 && ch[x] >= 0 && guard++ < 5000) { counts[ch[x]]++; x = Math.max(0, x - packs[ch[x]].c); }
        const used = packs.map((p, i) => ({ p, n: counts[i] })).filter((u) => u.n > 0).sort((a, b) => b.p.kg - a.p.kg);
        const covers = used.reduce((s, u) => s + u.n * u.p.c, 0);
        const total = used.reduce((s, u) => s + u.n * u.p.v.p, 0);
        put([{ b: used.map((u) => u.n + ' × ' + u.p.kg + ' kg').join(' + ') }, ' (covers ' + covers + ' m²) · ' + this.fmt(total) + ' inc VAT']);
        c.glueItems = used.map((u) => this.itemMeta(u.p.v, u.n));
        show(add, true);
      }
    }

    /* ---------- Sticky bar ---------- */
    m_sticky() {
      const st = $(this, '[data-emx-sticky]');
      const actions = $(this, '[data-emx-actions]');
      this.stk = { el: st, past: false, footer: false, on: false };
      if (!st || !actions || !this.d.sticky || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((es) => {
        es.forEach((e) => { this.stk.past = !e.isIntersecting && e.boundingClientRect.top < 0; });
        this.updSticky();
      });
      io.observe(actions);
      this._obs.push(io);
      /* An observer only fires on crossings; a jump straight past the buy box (e.g. the reviews link)
         never crosses, so also check position on scroll (once per frame). */
      let sraf = 0;
      const check = () => {
        sraf = 0;
        const past = actions.getBoundingClientRect().bottom < 0;
        if (past !== this.stk.past) { this.stk.past = past; this.updSticky(); }
      };
      this.on(window, 'scroll', () => { if (!sraf) sraf = requestAnimationFrame(check); }, { passive: true });
      this.on(window, 'hashchange', () => this.later(check, 50));
      this._off.push(() => { if (sraf) cancelAnimationFrame(sraf); });
      const footer = document.querySelector('#shopify-section-footer') || document.querySelector('footer');
      if (footer) {
        const io2 = new IntersectionObserver((es) => { es.forEach((e) => { this.stk.footer = e.isIntersecting; }); this.updSticky(); });
        io2.observe(footer);
        this._obs.push(io2);
      }
      this.on($(st, '[data-emx-sticky-atc]'), 'click', (e) => {
        if (!this.form) return;
        this._stickyBtn = e.currentTarget;
        this.submitMain(e.currentTarget);
      });
      this.on($(st, '[data-emx-goto-options]'), 'click', () => this.gotoOptions());
      this.on(window, 'resize', () => this.updSticky(), { passive: true });
    }
    updSticky() {
      const s = this.stk;
      if (!s || !s.el) return;
      const deskOk = this.d.stickyDesktop || !mq('(min-width: 1024px)');
      const on = !!(s.past && !s.footer && !this._overlays.size && deskOk);
      if (on === s.on) return;
      s.on = on;
      s.el.classList.toggle('is-visible', on);
      s.el.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) s.el.removeAttribute('inert'); else s.el.setAttribute('inert', '');
      if (!on && s.el.contains(document.activeElement) && this.atc) { try { this.atc.focus({ preventScroll: true }); } catch (_) { /* noop */ } }
      document.body.classList.toggle('emx-sticky-on', on);
      /* Keep keyboard focus from scrolling under the bar (WCAG 2.4.11). */
      try { document.documentElement.style.scrollPaddingBottom = on ? 'calc(' + ((s.el.offsetHeight || 64) + 16) + 'px + env(safe-area-inset-bottom))' : ''; } catch (_) { /* noop */ }
    }
    overlay(name, open) {
      if (open) this._overlays.add(name); else this._overlays.delete(name);
      this.updSticky();
    }
    gotoOptions() {
      const target = $(this, '.emx-opt:not([hidden])') || $(this, '[data-emx-block="buy_buttons"]');
      if (!target) return;
      target.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
      const r = $(target, 'input[type="radio"]:checked') || $(target, 'input:not([type="hidden"]), select, button');
      if (r) { try { r.focus({ preventScroll: true }); } catch (_) { r.focus(); } }
    }
    rSticky() {
      const s = this.stk;
      if (!s || !s.el) return;
      const v = this.state.variant;
      const t = this.totals();
      const opt = this.optSummary(v);
      /* Quantity first, so a two-line clamp on small phones drops options, never the quantity.
         Edging/corners are counted too, so the bar's quantity matches its price. */
      const qn = this.state.qty;
      const accN = Object.keys(this.state.acc).reduce((n, k) => n + (this.state.acc[k] > 0 ? this.state.acc[k] : 0), 0);
      let q = qn > 0 ? (this.metre ? qn + ' m' : 'Qty ' + qn) : '';
      if (accN) q = q ? q + ' + ' + accN + ' edging' : 'Edging only · ' + accN + (accN === 1 ? ' pc' : ' pcs');
      setText($(s.el, '[data-emx-sticky-summary]'), qn > 0 && opt ? q + ' · ' + opt : q);
      /* Sold-out variants are left out of totals(); show the unit price rather than £0.00. */
      const price = t.items.length ? (this.d.taxExempt ? t.ex : t.inc) : (v ? this.disp(v, v.p) : 0);
      setText($(s.el, '[data-emx-sticky-price]'), this.fmt(price));
      /* Under 360px the price column is hidden (CSS): this line carries quantity and running total instead. */
      setText($(s.el, '[data-emx-sticky-mini]'), (q ? q + ' · ' : '') + this.fmt(price));
      const b = $(s.el, '[data-emx-sticky-atc]');
      if (b && this.atc) {
        if (!this._busy) b.disabled = this.atc.disabled;
        const l = $(this.atc, '[data-emx-atc-label]');
        setText(b, l ? l.textContent : 'Add to basket');
      }
    }

    /* ---------- Added panel ---------- */
    m_added() {
      const p = $(this, '[data-emx-added]');
      this.addedEl = p;
      if (!p) return;
      this.on($(p, '[data-emx-added-close]'), 'click', () => this.closeAdded());
      this.on(document, 'keydown', (e) => { if (e.key === 'Escape' && !p.hidden) this.closeAdded(); });
      this.on(document, 'pointerdown', (e) => { if (!p.hidden && !p.contains(e.target)) this.closeAdded(true); });
      /* Non-modal sheet: when keyboard focus leaves it, close it, so the newly focused content is never
         hidden behind it (WCAG 2.4.11). */
      this.on(p, 'focusout', (e) => {
        if (p.hidden) return;
        if (e.relatedTarget) { if (!p.contains(e.relatedTarget)) this.closeAdded(true); return; }
        /* Focus moving into an iframe (Loox reviews, TrustBox) has no relatedTarget: check where it landed. */
        this.later(() => { const a = document.activeElement; if (!p.hidden && a && a !== document.body && !p.contains(a)) this.closeAdded(true); }, 0);
      });
    }
    openAdded(items, data, cart, btn) {
      const p = this.addedEl;
      if (!p) return;
      const list = $(p, '[data-emx-added-items]');
      const imgs = {};
      ((data && data.items) || []).forEach((li) => { if (li && li.variant_id) imgs[li.variant_id] = li.image || (li.featured_image && li.featured_image.url) || null; });
      if (list) {
        list.textContent = '';
        items.forEach((it) => {
          const li = document.createElement('li');
          li.className = 'emx-added__item';
          const src = it.img || imgs[it.id];
          if (src) {
            const im = document.createElement('img');
            im.src = /width=/.test(src) ? src : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=96';
            im.alt = ''; im.width = 48; im.height = 48; im.loading = 'lazy';
            li.appendChild(im);
          }
          const tx = document.createElement('div');
          tx.className = 'emx-added__text';
          const t1 = document.createElement('p'); t1.className = 'emx-added__name'; t1.textContent = it.title; tx.appendChild(t1);
          if (it.option) { const t2e = document.createElement('p'); t2e.className = 'emx-added__opt'; t2e.textContent = it.option; tx.appendChild(t2e); }
          if (it.props && it.props[CUT_PROP]) { const tc = document.createElement('p'); tc.className = 'emx-added__opt'; tc.textContent = CUT_PROP + ': ' + it.props[CUT_PROP]; tx.appendChild(tc); }
          const t3 = document.createElement('p'); t3.className = 'emx-added__qty'; t3.textContent = 'Qty ' + (it.metre ? it.quantity + ' m' : it.quantity); tx.appendChild(t3);
          li.appendChild(tx);
          const pr = document.createElement('p'); pr.className = 'emx-added__price exemptify_ignore'; pr.textContent = this.fmt(it.price * it.quantity);
          li.appendChild(pr);
          list.appendChild(li);
        });
      }
      const sub = $(p, '[data-emx-added-subtotal]');
      if (sub) {
        if (cart && typeof cart.total_price === 'number') {
          sub.textContent = 'Basket subtotal: ' + this.fmt(cart.total_price);
          sub.hidden = false;
        } else sub.hidden = true;
      }
      this._addedRet = btn && btn.isConnected && !btn.closest('[data-emx-sticky]') ? btn : this.atc;
      p.hidden = false;
      requestAnimationFrame(() => p.classList.add('is-open'));
      this.overlay('added', true);
      document.body.classList.add('emx-added-on');
      const h = $(p, '.emx-added__title');
      if (h) { try { h.focus({ preventScroll: true }); } catch (_) { h.focus(); } }
    }
    closeAdded(noFocus) {
      const p = this.addedEl;
      if (!p || p.hidden) return;
      p.classList.remove('is-open');
      p.hidden = true;
      this.overlay('added', false);
      document.body.classList.remove('emx-added-on');
      const r = this._addedRet;
      if (!noFocus && r && r.focus) { try { r.focus({ preventScroll: true }); } catch (_) { r.focus(); } }
    }

    /* ---------- "You may also need" ---------- */
    m_fbt() {
      const sec = $(this, '[data-emx-fbt]');
      this.fbt = sec;
      if (!sec) return;
      this.on(sec, 'change', (e) => {
        const sel = e.target.closest && e.target.closest('[data-emx-fbt-select]');
        if (sel) {
          const item = sel.closest('[data-emx-fbt-item]');
          const o = sel.options[sel.selectedIndex];
          const chk = $(item, '[data-emx-fbt-check]');
          if (chk && o) { chk.value = o.value; chk.setAttribute('data-price', o.getAttribute('data-price') || '0'); }
          setText($(item, '[data-emx-fbt-price]'), this.fmt(Number(o ? o.getAttribute('data-price') : 0)));
        }
        this.rFbt();
      });
      this.on($(sec, '[data-emx-fbt-add]'), 'click', (e) => {
        const items = $$(sec, '[data-emx-fbt-check]:checked').map((c) => {
          const item = c.closest('[data-emx-fbt-item]');
          const sel = $(item, '[data-emx-fbt-select]');
          const opt = sel && sel.options[sel.selectedIndex] ? lbl(sel.options[sel.selectedIndex].textContent.split(' – ')[0]) : '';
          return { id: Number(c.value), quantity: 1, title: c.getAttribute('data-title') || '', option: opt, img: c.getAttribute('data-img') || null, price: Number(c.getAttribute('data-price')) || 0, metre: false };
        }).filter((i) => i.id);
        if (items.length) this.addItems(items, e.currentTarget, { errorEl: $(sec, '[data-emx-fbt-error]') });
      });
      if (this.d.complementary && this.d.pid) {
        const run = () => this.loadComplementary();
        if ('requestIdleCallback' in window) { const id = window.requestIdleCallback(run, { timeout: 4000 }); this._off.push(() => { try { window.cancelIdleCallback(id); } catch (_) { /* noop */ } }); }
        else this.later(run, 1500);
      }
      this.rFbt();
    }
    async loadComplementary() {
      const sec = this.fbt;
      const list = $(sec, '[data-emx-fbt-list]');
      if (!sec || !list) return;
      const root = (window.routes && window.routes.productRecommendationsUrl) || '/recommendations/products';
      let data;
      try {
        const r = await fetch(root + '.json?product_id=' + enc(this.d.pid) + '&limit=' + enc(this.d.fbtLimit || 4) + '&intent=complementary', { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: this.signal() });
        if (!r.ok) return;
        data = await r.json();
      } catch (e) { if (!(e && e.name === 'AbortError')) warn(e); return; }
      const prods = ((data && data.products) || []).filter((p) => p && p.id !== this.d.pid && p.available !== false).slice(0, this.d.fbtLimit || 4);
      if (!prods.length || !this.isConnected) return;
      list.textContent = '';
      prods.forEach((p, k) => list.appendChild(this.fbtCard(p, k)));
      sec.hidden = false;
      this.rFbt();
    }
    fbtCard(p, k) {
      const sid = this.d.sid;
      const short = shortName(p.title);
      const avail = (p.variants || []).filter((v) => v.available);
      const v0 = avail[0] || (p.variants || [])[0];
      const price = (v) => (this.d.taxExempt && v.taxable ? Math.round(v.price / (1 + (Number(this.d.vat) || 20) / 100)) : v.price);
      const li = document.createElement('li');
      li.className = 'emx-fbt__item';
      li.setAttribute('data-emx-fbt-item', '');
      /* The image is a second (mouse / touch only) link to the product: a bigger tap target. */
      const media = document.createElement('a');
      media.className = 'emx-fbt__media';
      media.href = p.url;
      media.tabIndex = -1;
      media.setAttribute('aria-hidden', 'true');
      let img = p.featured_image || (p.images && p.images[0]) || '';
      if (img && typeof img === 'object') img = img.src || img.url || '';
      if (img) {
        const im = document.createElement('img');
        const u = String(img);
        im.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        im.alt = ''; im.loading = 'lazy'; im.width = 80; im.height = 80; im.className = 'emx-fbt__img';
        media.appendChild(im);
      }
      li.appendChild(media);
      const body = document.createElement('div');
      body.className = 'emx-fbt__body';
      const a = document.createElement('a');
      a.className = 'emx-fbt__name'; a.href = p.url; a.textContent = short; a.title = p.title || short;
      body.appendChild(a);
      if (avail.length > 8) {
        /* Too many choices for a dropdown: send them to the product page instead. */
        const from = avail.reduce((m, v) => Math.min(m, price(v)), Infinity);
        const fp = document.createElement('p');
        fp.className = 'emx-fbt__price exemptify_ignore';
        fp.textContent = 'From ' + this.fmt(from);
        body.appendChild(fp);
        const ch = document.createElement('a');
        ch.className = 'emx-btn emx-btn--ghost emx-btn--sm emx-fbt__choose';
        ch.href = p.url;
        ch.textContent = 'Choose options';
        const vh = document.createElement('span'); vh.className = 'emx-vh'; vh.textContent = ' for ' + short; ch.appendChild(vh);
        body.appendChild(ch);
        li.appendChild(body);
        return li;
      }
      if (avail.length > 1) {
        const sel = document.createElement('select');
        sel.className = 'emx-select emx-fbt__select';
        sel.setAttribute('aria-label', 'Option for ' + short);
        sel.setAttribute('data-emx-fbt-select', '');
        avail.forEach((v) => {
          const o = document.createElement('option');
          o.value = v.id; o.setAttribute('data-price', price(v));
          o.textContent = lbl(v.title) + ' – ' + this.fmt(price(v));
          sel.appendChild(o);
        });
        body.appendChild(sel);
      }
      const pr = document.createElement('p');
      pr.className = 'emx-fbt__price exemptify_ignore';
      pr.setAttribute('data-emx-fbt-price', '');
      pr.textContent = v0 ? this.fmt(price(v0)) : '';
      body.appendChild(pr);
      const pick = document.createElement('div');
      pick.className = 'emx-fbt__pick';
      const id = 'emx-fbt-' + sid + '-c' + (k + 1);
      const chk = document.createElement('input');
      chk.type = 'checkbox'; chk.className = 'emx-fbt__check'; chk.id = id;
      chk.value = v0 ? v0.id : '';
      chk.setAttribute('data-price', v0 ? price(v0) : 0);
      chk.setAttribute('data-title', short);
      if (img) chk.setAttribute('data-img', String(img));
      chk.setAttribute('data-emx-fbt-check', '');
      const lab = document.createElement('label');
      lab.htmlFor = id; lab.textContent = 'Add to my order';
      const lvh = document.createElement('span'); lvh.className = 'emx-vh'; lvh.textContent = ' – ' + short; lab.appendChild(lvh);
      pick.appendChild(chk); pick.appendChild(lab);
      body.appendChild(pick);
      li.appendChild(body);
      return li;
    }
    rFbt() {
      const sec = this.fbt;
      if (!sec) return;
      const btn = $(sec, '[data-emx-fbt-add]');
      if (!btn) return;
      const checked = $$(sec, '[data-emx-fbt-check]:checked');
      const total = checked.reduce((s, c) => s + (Number(c.getAttribute('data-price')) || 0), 0);
      if (!this._busy) btn.disabled = !checked.length;
      setText(btn, checked.length ? 'Add ' + checked.length + ' selected · ' + this.fmt(total) : 'Add selected to basket');
    }

    /* ---------- Quote dialog + contact prefill ---------- */
    m_quote() {
      const dlg = $(this, '[data-emx-quote]');
      this.quote = dlg;
      this.on(this, 'click', (e) => {
        const w = e.target.closest && e.target.closest('[data-emx-wa]');
        if (w && this.contains(w)) {
          /* WhatsApp: the prefilled URL lives in data-emx-wa-url (no wa.me href, which a site-wide script
             would rewrite to a generic message); without JS the link opens the contact page. */
          const url = w.getAttribute('data-emx-wa-url');
          if (url) {
            e.preventDefault();
            let win = null;
            try { win = window.open(url, '_blank'); } catch (_) { win = null; }
            if (win) { try { win.opener = null; } catch (_) { /* noop */ } } else window.location.href = url;
          }
          return;
        }
        const b = e.target.closest && e.target.closest('[data-emx-quote-open]');
        if (!b || !dlg) return;
        e.preventDefault();
        this.openQuote(b);
      });
      if (!dlg) return;
      this.on($(dlg, '[data-emx-close]'), 'click', () => closeDialog(dlg));
      this.on(dlg, 'click', (e) => { if (e.target === dlg) closeDialog(dlg); });
      this.on(dlg, 'close', () => {
        this.overlay('quote', false);
        const r = this._quoteRet;
        if (r && r.focus) { try { r.focus({ preventScroll: true }); } catch (_) { r.focus(); } }
      });
      /* Remember the dialog's purpose across the post / reload, so the reopened dialog keeps its heading. */
      const qf = $(dlg, 'form');
      this.on(qf, 'submit', () => store.set('emx-quote-mode', this._quoteMode || 'quote'));
      if ($(dlg, '[data-emx-quote-done], [data-emx-quote-err]')) this.later(() => this.openQuote(null, store.get('emx-quote-mode')), 50);
    }
    /* One dialog, three purposes: "quote" (trade), "advice" (Ask an expert), "sample". Copy comes from the
       data-emx-qt-<mode> attributes in snippets/emx-pdp-help.liquid. */
    quoteMode(mode) {
      const dlg = this.quote;
      if (!dlg) return;
      mode = mode === 'advice' || mode === 'sample' ? mode : 'quote';
      this._quoteMode = mode;
      $$(dlg, '[data-emx-qt]').forEach((el) => { const t = el.getAttribute('data-emx-qt-' + mode); if (t != null) setText(el, t); });
      const enq = $(dlg, '[data-emx-qf="enquiry"]');
      if (enq) { const t = enq.getAttribute('data-emx-qt-' + mode); if (t != null) enq.value = t; }
    }
    openQuote(trigger, mode) {
      const dlg = this.quote;
      if (!dlg) return;
      this._quoteRet = trigger || this.atc;
      this.quoteMode(mode || (trigger && trigger.getAttribute ? trigger.getAttribute('data-emx-quote-mode') : '') || 'quote');
      this.rHelp();
      openDialog(dlg);
      this.overlay('quote', true);
      /* After a submit the result note gets focus, so it is read out (a live region that is already in the
         page at load is not announced). On touch screens, focusing a text field pops the keyboard over the
         heading and intro, so focus the heading there and the first field only with a fine pointer. */
      let f;
      const res = $(dlg, '[data-emx-quote-done], [data-emx-quote-err]');
      if (res) f = res;
      else if (mq('(pointer: fine)')) f = $(dlg, 'input:not([type="hidden"]), textarea');
      else f = $(dlg, '.emx-dialog__title') || $(dlg, '[data-emx-close]');
      if (f) { try { f.focus(); } catch (_) { /* noop */ } }
    }
    rHelp() {
      const v = this.state.variant;
      if (!v) return;
      const origin = window.location.origin || this.d.origin || '';
      const link = origin + this.d.url + '?variant=' + v.id;
      /* Adhesive over 2,000 m²: the enquiry is about the area, not the selected pack size. */
      const qa = this.calc && this.calc.type === 'adhesive' && this.calc.quoteArea ? this.calc.quoteArea : 0;
      const areaTxt = qa ? 'Area to cover: ' + qa.toLocaleString('en-GB') + ' m²' : '';
      const opt = qa ? '' : this.optText(v);
      const q = qa ? areaTxt : this.qtyText();
      const email = this.d.email || '';
      if (email) {
        const subject = 'Product enquiry: ' + this.d.title;
        const body = ['Product: ' + this.d.full, 'Option: ' + opt, 'SKU: ' + (qa ? '' : (v.s || '')), qa ? areaTxt : 'Quantity: ' + q, 'Link: ' + link].join('\n');
        const href = 'mailto:' + email + '?subject=' + enc(subject) + '&body=' + enc(body);
        $$(this, '[data-emx-mailto]').forEach((a) => { if (a.getAttribute('href') !== href) a.setAttribute('href', href); });
      }
      if (this.d.wa) {
        const text = 'Hi, I\'m interested in ' + this.d.title + (opt ? ' (' + opt + ')' : '') + (qa ? ', ' + areaTxt.toLowerCase() : ', qty ' + q) + ': ' + link;
        const url = 'https://wa.me/' + String(this.d.wa).replace(/\D/g, '') + '?text=' + enc(text);
        $$(this, '[data-emx-wa]').forEach((a) => { if (a.getAttribute('data-emx-wa-url') !== url) a.setAttribute('data-emx-wa-url', url); });
      }
      const dlg = this.quote;
      if (dlg) {
        const set = (k, val) => { const i = $(dlg, '[data-emx-qf="' + k + '"]'); if (i) i.value = val; };
        set('product', this.d.full);
        set('option', opt);
        set('sku', qa ? '' : (v.s || ''));
        set('quantity', q);
        set('page', link);
        setText($(dlg, '[data-emx-qf-show="option"]'), opt);
        const sep = $(dlg, '[data-emx-qf-sep]');
        if (sep) show(sep, !!opt);
        const body = $(dlg, 'textarea[name="contact[body]"]');
        if (body && qa && (!body.value || body.value === body._emxAuto)) { body.value = areaTxt; body._emxAuto = areaTxt; }
      }
    }

    /* ---------- Details: accordions + hash handling ---------- */
    m_details() {
      this.on(this, 'click', (e) => {
        const a = e.target.closest && e.target.closest('a[href^="#emx-"]');
        if (!a || !this.contains(a)) return;
        const id = a.getAttribute('href').slice(1);
        if (id.indexOf('emx-acc-') === 0) return;
        if (this.openTarget(id, true)) e.preventDefault();
      });
      this.on(window, 'hashchange', () => this.openTarget(window.location.hash.slice(1), true));
      const h = window.location.hash.slice(1);
      if (h && h.indexOf('emx-') === 0) this.later(() => this.openTarget(h, true), 60);
    }
    openTarget(id, scroll) {
      if (!id) return false;
      let el = null;
      try { el = document.getElementById(decodeURIComponent(id)); } catch (_) { el = document.getElementById(id); }
      if (!el || !this.contains(el)) return false;
      const det = el.tagName === 'DETAILS' ? el : el.closest('details');
      if (det) det.open = true;
      if (scroll) el.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
      const sum = det ? $(det, 'summary') : null;
      if (sum) { try { sum.focus({ preventScroll: true }); } catch (_) { /* noop */ } }
      return true;
    }

    /* ---------- Theme product cards on this page (You may also like / Recently viewed) ----------
       Card titles show the product name only (text before " | "); the full title stays in the title
       attribute. Product pages only: the theme's product-item snippet is untouched. */
    m_cards() {
      const fix = (root) => {
        $$(root, '.product-item__title').forEach((a) => {
          if (a.hasAttribute('data-emx-short')) return;
          const full = (a.textContent || '').trim();
          if (full.indexOf(' | ') === -1) return;
          a.setAttribute('data-emx-short', '');
          if (!a.getAttribute('title')) a.setAttribute('title', full);
          a.textContent = full.split(' | ')[0].trim();
        });
      };
      $$(document, '.shopify-section[id$="__product-recommendations"], .shopify-section[id$="__recently-viewed-products"]').forEach((sec) => {
        fix(sec);
        if (!('MutationObserver' in window)) return;
        const mo = new MutationObserver(() => fix(sec));
        mo.observe(sec, { childList: true, subtree: true });
        this._obs.push(mo);
      });
    }

    /* ---------- Trustpilot TrustBox ---------- */
    m_trust() {
      const run = () => {
        if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== 'function') return;
        $$(this, '.trustpilot-widget').forEach((el) => {
          if (!$(el, 'iframe')) { try { window.Trustpilot.loadFromElement(el, true); } catch (e) { warn(e); } }
        });
      };
      if (document.readyState === 'complete') this.later(run, 1500);
      else this.on(window, 'load', () => this.later(run, 1500), { once: true });
    }
  }

  customElements.define('emx-pdp', EmxPdp);
})();
